import React, { useCallback, useState, useEffect } from "react";
import { useRecoilState } from "recoil";
// __apis__
import { fetchMealsTrackingStatus } from "src/__apis__/mealsTracking";
// atoms
import mealsTrackingStatusAtom from "src/recoil/atoms/mealsTrackingStatusAtom";

// ------------------------------------------------------------------------------------------------------------------

function useMealsInTakeTrackingStatus() {
  const [fetchingMealsStatus, setFetchingMealsStatus] = useState(false);

  const [mealsTrackingStatus, setMealsTrackingStatus] = useRecoilState(
    mealsTrackingStatusAtom,
  );

  const mealsTrackingStatusFetcher = useCallback(async () => {
    setFetchingMealsStatus(true);
    fetchMealsTrackingStatus()
      .then((response) => {
        setMealsTrackingStatus(response);
        setFetchingMealsStatus(false);
      })
      .catch((error) => {
        console.log("Error fetching meals status", error);
      });
  }, [
    setFetchingMealsStatus,
    setMealsTrackingStatus,
    fetchMealsTrackingStatus,
  ]);

  useEffect(() => {
    mealsTrackingStatusFetcher();
  }, []);

  return [mealsTrackingStatusFetcher, mealsTrackingStatus];
}

export default useMealsInTakeTrackingStatus;
